import envService from "@/services/env.service";
import axios from 'axios';

const BASE_URL = envService.getApiBaseUrl() + '/sms/parts';

export default {
  splitSms(message) {
    return axios.post(BASE_URL, { message });
  }
}